import React, { useState, useEffect } from 'react';
import { ContentContainer, Callout, Row, Col, Button, FormHeader, ComponentLoader, InPageAlert, ErrorSummary, Input, Field } from '@snsw-gel/react';
import { history } from '@starterapp/shared-services/history';
import { postLinking } from '../../../services/api-services';
import styles from './ValidateCardNumber.module.scss';
import { dataLayer } from '../../../services/gtm-dataLayer';

const ValidateCardNumberPage = () => {
    const [cardNumber, setCardNumber] = useState('');
    const [cardAlreadyLinked, setCardAlreadyLinked] = useState(false);
    const [cardInvalid, setCardInvalid] = useState(false);
    const [showSpinner, setShowSpinner] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [notNumber, setNotNumber] = useState(false);
    const [empty, setEmpty] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');


    const notNumberRegex = value => value && !/^[0-9]+$/i.test(value);

    useEffect(() => {
        const currentUrl = window.location.href;
        const pageName = window.location.href.split('/').pop();
        dataLayer(currentUrl, pageName);
    }, []);


    const onSubmitApplication = () => async _ => {
        setHasError(false)
        setCardAlreadyLinked(false);
        setCardInvalid(false);
        setNotNumber(false);
        setEmpty(false);
        setErrorMessage('');

        if (cardNumber === '') {
            setHasError(true);
            setEmpty(true);
            setErrorMessage('Enter a valid card number.');
            setNotNumber(false);
            return;
        } else if (notNumberRegex(cardNumber)) {
            setHasError(true);
            setNotNumber(true);
            setErrorMessage('Enter numbers only.');
            setEmpty(false);
            return;
        }

        setShowSpinner(true);

        let response;
        try {
            response = await postLinking(cardNumber.trim());
        } catch (ex) { }

        setShowSpinner(false);

        if (!response._httpStatus || response._httpStatus === 200) {
            window.location.href = process.env.REACT_APP_SENIORS_DASHBOARD_URL + process.env.REACT_APP_LINKED_PARAMS;
        } else {
            switch (response.type) {
                case undefined:
                case 'failedLinkingRequest':
                    history.push('/applicationError');
                    window.dispatchEvent(new PopStateEvent('popstate'));
                    break;
                case 'validation':
                    history.push('/link/linkingError');
                    window.dispatchEvent(new PopStateEvent('popstate'));
                    break;
                case 'invalidSeniorsCardId':
                case "":
                case 'noLink':
                    setCardInvalid(true);
                    setHasError(true);
                    setErrorMessage('Enter a valid card number.');
                    break;
                case 'alreadyLinked':
                    setHasError(false);
                    setCardAlreadyLinked(true);
                    break;
                default:
                    break;
            }
        }
    };

    return (
        <>
            <FormHeader
                label='Apply or manage a NSW Seniors Card or NSW Senior Savers Card '
                title=' Confirm your card number'
            />

            <ContentContainer className={styles['content-container']}>

                {
                    cardAlreadyLinked && (
                        <Row>
                            <Col span={6}>
                                <InPageAlert
                                    variant='error'
                                    title='This Card number has already been added to another MyServiceNSW Account'>
                                    <p>Your card can only be used in one account. For more information visit our <a className={styles['card-exist-link']} href='https://www.service.nsw.gov.au/services/myservicensw-account/multiple-accounts'>Help with multiple accounts</a>.</p>
                                </InPageAlert>
                            </Col>
                        </Row>
                    )
                }
                <Row>
                    <Col span={8}>

                        {hasError && (empty || cardInvalid) ?   <div className={styles['error-margin']}> <ErrorSummary errors={[{ id: 'cardNumber', text: 'Enter a valid card number.' }]} /> </div> : <></>}

                        {hasError && notNumber ?   <div className={styles['error-margin']}><ErrorSummary errors={[{ id: 'cardNumber', text: 'Enter numbers only.' }]} /> </div> : <></>}

                            <Field
                             hasError={hasError}
                            label='Enter your NSW Seniors Card or NSW Senior Savers Card number'
                            id='cardNumber'
                            helpMessage='This number is on the front of your card.'
                            errorMessage={errorMessage}
                            isRequired
                            className= {`${styles['form-input']} ${hasError||cardInvalid ? styles['has-error'] : ''}`}
                            >
                            <Input
                             hasError={hasError}
                            value={cardNumber}
                            onChange={(ev) => {
                            setCardNumber(ev.target.value)
                            }}
                            inputWidth='md'
                            />
                            </Field>

                        <Callout
                          className= {`${styles['support-section']} ${hasError||cardInvalid ? styles['has-error'] : ''}`}

                        title='Support for adding your card issues'>
                            <ul>
                                <li>Visit your nearest <a href='https://www.service.nsw.gov.au/service-centre'>service centre</a>.</li>
                                <li>Call us on <a aria-label='Call us on 1 3 7 7 8 8' href='tel:137788'>13 77 88</a>.</li>
                            </ul>
                        </Callout>
                    </Col>
                </Row>

                <Row>
                    <Col span={12}>
                        <Button
                            className={styles['continue-button']}
                            id='continueButton'
                            onClick={onSubmitApplication()}
                        >
                            Continue
                        </Button>
                    </Col>
                </Row>
            </ContentContainer>
            {
                showSpinner && (<ComponentLoader fullPage />)
            }
        </>
    );
};

export default ValidateCardNumberPage;
